import styled from 'styled-components';

export const FormPage = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
  display: flex;
  justify-content: center;
`;

export const FormCard = styled.form`
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  padding: ${({ theme }) => theme.spacing(4)};
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const FormSectionTitle = styled.h3`
  margin: ${({ theme }) => theme.spacing(0, 0, 0.5, 0)};
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.75)};
`;

export const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const RequiredIndicator = styled.span`
  color: ${({ theme }) => theme.palette.error.main};
  margin-left: ${({ theme }) => theme.spacing(0.25)};
`;

export const FieldError = styled.p`
  margin: ${({ theme }) => theme.spacing(0.5, 0, 0)};
  font-size: 12px;
  color: ${({ theme }) => theme.palette.error.main};
  white-space: pre-line;
`;

export const NoteRow = styled.div`
  margin-top: ${({ theme }) => theme.spacing(1.5)};
`;

export const SkippedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const SkippedBox = styled.div`
  border: 1px solid ${({ theme }) => theme.ui.border.main};
  border-radius: 8px;
  overflow: hidden;
`;

// Bounds the modal height once expanded — a long cohort scrolls instead of pushing Continue off-screen.
export const SkippedScroll = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 288px;
  overflow-y: auto;
`;

export const SkippedRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(1.25, 1.75)};
  font-size: 14px;

  & + & {
    border-top: 1px solid ${({ theme }) => theme.palette.divider};
  }
`;

export const SkippedName = styled.span`
  flex: 1;
  min-width: 0;
  color: ${({ theme }) => theme.palette.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SkippedReasonText = styled.span`
  flex-shrink: 0;
  padding: ${({ theme }) => theme.spacing(0.25, 1.25)};
  border-radius: 12px;
  font-size: 12px;
  background: ${({ theme }) => theme.palette.grey[100]};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ConfirmError = styled.p`
  margin: ${({ theme }) => theme.spacing(0, 0, 1.5)};
  font-size: 14px;
  color: ${({ theme }) => theme.palette.error.main};
  white-space: pre-line;
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding-top: ${({ theme }) => theme.spacing(1)};
`;
